import { trenballColors } from '@/constants/trenball-colors';
import TrendTutorialExample from './Example';
import { trenballExamples } from '@/constants/trenball-examples';
import styles from './styles.module.scss';
import { CrashTrenballColor } from '@/models/crash/trenball/color';

export default function TrendTutorialModalContent() {
  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__row} ${styles['container__row--center']}`}
      >
        <div
          className={`${styles.container__row} ${styles['container__row--small']}`}
        >
          <div
            className={styles.container__dot}
            style={{
              backgroundColor: trenballColors.get(CrashTrenballColor.Green),
            }}
          />
          <span className={styles.container__label}>≥2×</span>
        </div>

        <div
          className={`${styles.container__row} ${styles['container__row--small']}`}
        >
          <div
            className={styles.container__dot}
            style={{
              backgroundColor: trenballColors.get(CrashTrenballColor.Orange),
            }}
          />
          <span className={styles.container__label}>{`<2×`}</span>
        </div>

        <div
          className={`${styles.container__row} ${styles['container__row--small']}`}
        >
          <div
            className={styles.container__dot}
            style={{
              backgroundColor: trenballColors.get(CrashTrenballColor.Yellow),
            }}
          />
          <span className={styles.container__label}>≥10×</span>
        </div>
      </div>

      {trenballExamples.map((example, i) => (
        <TrendTutorialExample key={`trenball_example_${i}`} {...example} />
      ))}
    </div>
  );
}
